import { List, Tooltip as AntTooltip } from "antd";
import { format, parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { style0, style1, style2, style3, style4, style5 } from "./styles";
import { useSelector } from "react-redux";

const MessagesList = ({
  messages=[],
  item_id,
  user,
}) => {
  const [obligationMessages, setObligationMessages] = useState([]);
  const targetId = useSelector(state => state.obligations.navigateId);
  
  useEffect(()=>{
    if(targetId){
      setObligationMessages(messages.filter(item=>item.obligation_id===targetId));
    }
    else{
      setObligationMessages(messages.filter(item=>item.obligation_id===item_id));
    }

  },[messages])

  console.debug("messages:",messages);
  console.debug("obligationMessages:",obligationMessages);
  console.debug("NAVIGATEID:",targetId);

  const description = (item) => {
    return(
      <div>
        <div>
          <span 
            style={{
              width:"40px", 
              position:"absolute",
              // top:"14px", 
              // marginTop:"2px",
              left:"20px", 
              height:"20px", 
              color:"#00000096", 
              display: "flex", 
              alignItems: "right", 
              justifyContent: "right", 
              textAlign:"right", 
              fontFamily: "Roboto",
              fontSize: "10.74px",
              fontWeight: "600",
              lineHeight: "13.14px",
              textAlign: "right",
            }}>
            {item.createdAt &&
            parseISO(item.createdAt) &&
            format(
              parseISO(item.createdAt),
              "dd.MM.yy"
            )}
            <br/>
            {item.createdAt &&
            parseISO(item.createdAt) &&
            format(
              parseISO(item.createdAt),
              "HH:mm"
            )}
          </span>
          <AntTooltip
            title={() => (
              <div style={{ whiteSpace: "pre-wrap" }}>
                {item.user_firstName}&nbsp;{item.user_lastName}
              </div>
            )}
            arrow={false}
            overlayClassName="description-tooltip"
            mouseEnterDelay={0.5}
            placement="bottomLeft"
          >
            <span 
              style={
                parseInt(item.user_id.split('').reverse().join(''))%5 ?
                  parseInt(item.user_id.split('').reverse().join(''))%5===0 ?
                    style0 : parseInt(item.user_id.split('').reverse().join(''))%5===1 ? 
                      style1 : parseInt(item.user_id.split('').reverse().join(''))%5===2 ? 
                        style2 : parseInt(item.user_id.split('').reverse().join(''))%5===3 ? 
                          style3 : style4 : style5
              }
            >
                {item.user_firstName?.charAt(0)}{item.user_lastName?.charAt(0)}
            </span>
          </AntTooltip>
          <span style={{
              display: "flex",
              alignItems: "left", 
              justifyContent: "left",
              textAlign:"left",
              marginLeft:"110px",
              color:"#696969",
          }}>
              {item.message}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div 
      style={{ 
        height: '155px', 
        overflowY: obligationMessages.length > 0 ? 'scroll' : 'hidden', 
        // marginTop: "54px", 
        border: "1px solid #D0D5DD", 
        borderTopLeftRadius: "10px", 
        borderTopRightRadius: "10px" 
      }}
    >
      <List
        itemLayout="horizontal"
        dataSource={obligationMessages}
        style={{ border: "none" }}
        renderItem={(item, index) => (
          <List.Item style={{ border: "none", backgroundColor: "#FAFAFF" }}>
            <List.Item.Meta
              description={description(item)}
            />
          </List.Item>
        )}
      />
    </div>
  );
}

export default MessagesList;